import { useState } from 'react';

export const useParticularApplication = () => {
    const [applications, setApplications] = useState([]);
    const [particularApplication, setParticularApplication] = useState([]);

    return { particularApplication, setParticularApplication, setApplications, applications };
};
